import { DeliveryMode, OrderMethod } from '../../../../../../../services/exports/Constants';

export default {
  title: 'Czy zamówienie zajmie dłużej/krócej?',
  text: {
    [OrderMethod.Pickup]:
      'Klient oczekuje, że zamówienie będzie gotowe do odbioru <strong>{{date}}</strong> o <strong>{{time}}</strong><br/> W razie potrzeby możesz zmienić czas tutaj.',
    [OrderMethod.OnSite]:
      'Klient oczekuje zamówienia przy <strong>{{table}}</strong><br/><strong>{{date}}</strong> o <strong>{{time}}</strong><br/> W razie potrzeby możesz tutaj zmienić godzinę.',
    // A table order whose table the backend could not name.
    on_site_without_table:
      'Klient oczekuje zamówienia przy stoliku <strong>{{date}}</strong> o <strong>{{time}}</strong><br/> W razie potrzeby możesz tutaj zmienić godzinę.',
    [OrderMethod.Delivery]: {
      [DeliveryMode.Internal]:
        'Klient oczekuje dostawy zamówienia <strong>{{date}}</strong> o <strong>{{time}}</strong><br/> W razie potrzeby możesz zmienić czas tutaj.',
      [DeliveryMode.External]: 'Kierowca przyjedzie odebrać zamówienie o <strong>{{time}}{{confidenceLabel}}</strong>',
    },
  },
  labels: {
    today: 'Dzisiaj',
  },
  confidence_labels: {
    estimated: ' (szacunkowo!)',
    confirmed: '',
  },
  buttons: {
    confirm_pickup: 'Potwierdź nowy czas odbioru',
    confirm_on_site: 'Potwierdź nowy czas podania',
    confirm_delivery: 'Potwierdź nowy czas dostawy',
  },
  confirmation_modal: {
    description: 'Czy na pewno chcesz zmienić czas z {{currentPickupTime}} na {{newPickupTime}}?',
    ok_button_text: 'Potwierdź nowy czas',
    cancel_button_text: 'Nie, przywróć oryginalny czas',
  },
};
